import { ANALYTICS_EVENT_TYPES } from '../constants/analyticsEvents';
import useAnalytics, { type AnalyticsEvent } from './useAnalytics';

export function useSlideSetAnalytics() {
  const { capture } = useAnalytics();

  const captureOpened = (slideSetId: number, subLocationId: AnalyticsEvent['subLocationId']) => {
    if (!subLocationId) return;
    capture({ objectId: slideSetId.toString(), eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_ACCESSED, subLocationId });
    capture({
      objectId: slideSetId.toString(),
      eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_VIEWER_ACCESSED,
      subLocationId,
    });
  };

  const captureEditOpened = (slideSetId: number, subLocationId: AnalyticsEvent['subLocationId']) => {
    if (!subLocationId) return;
    capture({ objectId: slideSetId.toString(), eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_ACCESSED, subLocationId });
    capture({
      objectId: slideSetId.toString(),
      eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_EDIT_MODE_ACCESSED,
      subLocationId,
    });
  };

  const captureOverviewOpened = (slideSetId: number, subLocationId: AnalyticsEvent['subLocationId']) => {
    if (!subLocationId) return;
    capture({ objectId: slideSetId.toString(), eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_ACCESSED, subLocationId });
    capture({
      objectId: slideSetId.toString(),
      eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_OVERVIEW_ACCESSED,
      subLocationId,
    });
  };

  const captureDeleted = (slideSetId: number, subLocationId: AnalyticsEvent['subLocationId']) => {
    if (!subLocationId) return;
    capture({ objectId: slideSetId.toString(), eventType: ANALYTICS_EVENT_TYPES.SLIDE_SET_DELETED, subLocationId });
  };

  return { captureOpened, captureEditOpened, captureOverviewOpened, captureDeleted };
}
